import { Fragment } from "react";

import {
  DifferenceSectionBody,
  DifferenceSectionLeftCell,
  DifferenceSectionLeftHeaderCell,
  DifferenceSectionLeftHeaderLabel,
  DifferenceSectionLeftRowLabel,
  DifferenceSectionRightCell,
  DifferenceSectionRightHeader,
  DifferenceSectionRoot,
  DifferenceSectionTitle,
} from "../styles";

type ComparisonRow = {
  label: string;
  traditional: string;
  smaul: string;
};

const rows: ComparisonRow[] = [
  {
    label: "",
    traditional: "一般的な\n一括査定サイト",
    smaul: "スマウル",
  },
  {
    label: "電\n話",
    traditional: "5〜10社から\n昼夜問わず\n鳴り響く",
    smaul: "専任担当との\nやり取りのみ",
  },
  {
    label: "対\n応",
    traditional: "全社に同じ説明を\n繰り返す",
    smaul: "一度伝えて、\nあとは待つだけ",
  },
  {
    label: "信\n頼\n性",
    traditional: "安く買うための\n営業トーク",
    smaul: "プロが精査した\n「本気の最高値」",
  },
  {
    label: "立\nち\n位\n置",
    traditional: "安く買いたい\n業者との戦い",
    smaul: "中立な立場の\n専任コンシェルジュ",
  },
];

export default function DifferenceSection() {
  return (
    <DifferenceSectionRoot>
      <DifferenceSectionTitle>従来の売却との違い</DifferenceSectionTitle>

      <DifferenceSectionBody>
        <DifferenceSectionLeftHeaderLabel>{rows[0].label}</DifferenceSectionLeftHeaderLabel>
        <DifferenceSectionLeftHeaderCell>{rows[0].traditional}</DifferenceSectionLeftHeaderCell>
        <DifferenceSectionRightHeader>{rows[0].smaul}</DifferenceSectionRightHeader>

        {rows.slice(1).map((row, index) => (
          <Fragment key={`row-${index}`}>
            <DifferenceSectionLeftRowLabel>{row.label}</DifferenceSectionLeftRowLabel>
            <DifferenceSectionLeftCell>{row.traditional}</DifferenceSectionLeftCell>
            <DifferenceSectionRightCell
              $isLast={index === rows.length - 2}
            >
              {row.smaul}
            </DifferenceSectionRightCell>
          </Fragment>
        ))}
      </DifferenceSectionBody>
    </DifferenceSectionRoot>
  );
}
